import { useWindowWidth } from "shared/hooks/useWindowWidth";
import { Breakpoints } from "shared/types/breakpoints";

/**
 * Definição dos breakpoints em um objeto reutilizável
 */
export const BREAKPOINTS: { [key in keyof Breakpoints]: number } = {
  xs: 0, // Extra small - Telas menores que 640px (smartphones)
  sm: 640, // Small - Telas maiores que 640px (tablets)
  md: 768, // Medium - Telas maiores que 768px (desktops)
  lg: 1159, // Large  - Telas maiores que 1024px (desktops)
  xl: 1280, // Extra large - Telas maiores que 1280px (desktops)
  xxl: 1536, // 2x Extra large - Telas maiores que 1536px (desktops)
};

/**
 * Hook customizado para determinar o breakpoint atual baseado na largura da janela.
 *
 * @returns {keyof Breakpoints} Nome do breakpoint atual.
 */
export const useBreakpoint = (): keyof Breakpoints => {
  const width = useWindowWidth();

  // Itera sobre os breakpoints em ordem decrescente de tamanho
  const breakpoint = (Object.keys(BREAKPOINTS) as Array<keyof Breakpoints>)
    .reverse()
    .find((key) => width >= BREAKPOINTS[key]);

  return breakpoint || "xs"; // Retorna "xs" como padrão
};
